module.exports = __webpack_public_path__ + "img/contact-top.5c2c3a92.jpg";